import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useAddOrUpdateCompanyConfiguration } from "../hooks/useConfiguration";
import { handleMedia } from "../../../edetailing/repository/EdetailingRepository";

interface Props {
  data: any;
}

const CompanyConfigurationForm: React.FC<Props> = ({ data }) => {
  const [companyName, setCompanyName] = useState<string>("");
  const [companyLogo, setCompanyLogo] = useState<string | null>(null);
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");


  useEffect(() => {
    if (data?.data) {
      setCompanyName(data.data.owner_name || "");
      setPhone(data.data.company_phone_number || "");
      setCompanyLogo(data.data.company_logo.toString() || "");
      setAddress(data.data.company_address_1 || "");
    }
  }, [data]);

  const { mutate: AddOrUpdateCompanyConfiguration } =
    useAddOrUpdateCompanyConfiguration();
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        console.log("Uploaded Media ID:", mediaId);
        setCompanyLogo(mediaId);
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const submittedData = {
      owner_name: companyName,
      company_logo: companyLogo,
      //   signatory,
      company_phone_number: phone,
      company_address_1: address,
    };

    AddOrUpdateCompanyConfiguration(submittedData, {
      onSuccess: () => {},
      onError: (error) => {
        console.error("Error saving AddOrUpdateCompanyConfiguration:", error);
      },
    });
  };

  return (
    <Card className="p-2">
      <CardBody>
        <h4>Company Configuration</h4>
        <p style={{ color: "#767676" ,marginTop:8}}>Enter company details</p>
        <form onSubmit={handleSubmit}>
          <div className="row mt-3">
            <div className="col-md-6 mb-3">
              <label className="form-label">Company Name</label>
              <input
                className="form-control"
                type="text"
                name="companyName"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Company Logo</label>
              <input
                className="form-control"
                type="file"
                name="companyLogo"
                accept="image/*"
                onChange={handleFileChange}
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}

              />
              {companyLogo && (
                <img
                  src={`${BASE_URL}${companyLogo}`}
                  alt="Company Logo"
                  style={{
                    width: "150px",
                    height: "50px",
                    marginTop: "10px",
                    borderRadius: "8px",
                  }}
                />
              )}
            </div>

            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Authorized Signatory</label>
              <input
                className="form-control"
                type="text"
                name="signatory"
                value={signatory}
                onChange={(e) => setSignatory(e.target.value)}
                required
              />
            </div> */}

            <div className="col-md-6 mb-3">
              <label className="form-label">Phone</label>
              <input
                className="form-control"
                type="text"
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label">Communication Address</label>
              <textarea
                className="form-control"
                name="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              ></textarea>
            </div>
          </div>

          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
            >
              Submit
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              //   onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default CompanyConfigurationForm;
